var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-stretch border-bottom"},[_c('div',{staticClass:"mr-3"},[_c('div',{staticClass:"d-flex align-items-center justify-content-center bg-orange h-100 square-order"},[_c('span',{staticClass:"text-white h3 m-0",domProps:{"textContent":_vm._s(_vm.order)}})])]),_c('div',{staticClass:"w-100"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }